"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const uuid_1 = require("uuid");
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
class PathMapLayerManager {
    constructor(mapLayerManager) {
        this._layerName = 'transitPaths';
        this._hiddenAgencyIds = new Map();
        this._hiddenLineIds = new Map();
        this._layerManager = mapLayerManager;
        this.updateFromPreferences();
    }
    updateFromPreferences() {
        const hiddenAgencyIds = Preferences_1.default.get('map.layers.hiddenAgencyIds', []);
        const hiddenLineIds = Preferences_1.default.get('map.layers.hiddenLineIds', []);
        for (let i = 0, countI = hiddenAgencyIds.length; i < countI; i++) {
            if ((0, uuid_1.validate)(hiddenAgencyIds[i])) {
                this._hiddenAgencyIds.set(hiddenAgencyIds[i], true);
            }
        }
        for (let i = 0, countI = hiddenLineIds.length; i < countI; i++) {
            if ((0, uuid_1.validate)(hiddenLineIds[i])) {
                this._hiddenLineIds.set(hiddenLineIds[i], true);
            }
        }
    }
    agencyIsVisible(agencyId) {
        return !this.agencyIsHidden(agencyId);
    }
    agencyIsHidden(agencyId) {
        return this._hiddenAgencyIds.has(agencyId);
    }
    lineIsVisible(lineId) {
        return !this.lineIsHidden(lineId);
    }
    lineIsHidden(lineId) {
        return this._hiddenLineIds.has(lineId);
    }
    showAgencyId(agencyId) {
        if ((0, uuid_1.validate)(agencyId) && this._hiddenAgencyIds.has(agencyId)) {
            this._hiddenAgencyIds.delete(agencyId);
            this.showAllLinesForAgency(agencyId);
        }
    }
    showAllAgencies() {
        if (ServiceLocator_1.default.collectionManager.has('agencies')) {
            this._hiddenAgencyIds.clear();
            const agencies = ServiceLocator_1.default.collectionManager.get('agencies').getFeatures();
            for (let i = 0, countI = agencies.length; i < countI; i++) {
                const agencyId = agencies[i].get('id');
                this.showAllLinesForAgency(agencyId, false);
            }
            this.updateFilter();
        }
    }
    hideAgencyId(agencyId) {
        if ((0, uuid_1.validate)(agencyId) && !this._hiddenAgencyIds.has(agencyId)) {
            this._hiddenAgencyIds.set(agencyId, true);
            this.hideAllLinesForAgency(agencyId);
        }
    }
    hideAllAgencies() {
        if (ServiceLocator_1.default.collectionManager.has('agencies')) {
            this._hiddenAgencyIds.clear();
            const agencies = ServiceLocator_1.default.collectionManager.get('agencies').getFeatures();
            for (let i = 0, countI = agencies.length; i < countI; i++) {
                const agencyId = agencies[i].get('id');
                this._hiddenAgencyIds.set(agencyId, true);
                this.hideAllLinesForAgency(agencyId, false);
            }
            this.updateFilter();
        }
    }
    showLineId(lineId) {
        if ((0, uuid_1.validate)(lineId)) {
            this._hiddenLineIds.delete(lineId);
            this.updateFilter();
        }
    }
    showAllLinesForAgency(agencyId, updateFilter = true) {
        if (ServiceLocator_1.default.collectionManager.has('agencies')) {
            const agency = ServiceLocator_1.default.collectionManager.get('agencies').getById(agencyId);
            if (agency) {
                const lineIds = agency.get('line_ids', []);
                lineIds.forEach((lineId) => {
                    if ((0, uuid_1.validate)(lineId)) {
                        this._hiddenLineIds.delete(lineId);
                    }
                });
            }
            if (updateFilter) {
                this.updateFilter();
            }
        }
    }
    hideLineId(lineId) {
        if ((0, uuid_1.validate)(lineId) && !this._hiddenLineIds.has(lineId)) {
            this._hiddenLineIds.set(lineId, true);
            this.updateFilter();
        }
    }
    hideAllLinesForAgency(agencyId, updateFilter = true) {
        if (ServiceLocator_1.default.collectionManager.has('agencies')) {
            const agency = ServiceLocator_1.default.collectionManager.get('agencies').getById(agencyId);
            if (agency) {
                const lineIds = agency.get('line_ids', []);
                lineIds.forEach((lineId) => {
                    if ((0, uuid_1.validate)(lineId)) {
                        this._hiddenLineIds.set(lineId, true);
                    }
                });
            }
            if (updateFilter) {
                this.updateFilter();
            }
        }
    }
    clearFilter() {
        this._hiddenAgencyIds.clear();
        this._hiddenLineIds.clear();
        this.updateFilter();
    }
    updateFilter() {
        const hiddenAgencyIds = [];
        const hiddenLineIds = [];
        this._hiddenAgencyIds.forEach((isHidden, hiddenAgencyId) => {
            if (isHidden === true && (0, uuid_1.validate)(hiddenAgencyId)) {
                hiddenAgencyIds.push(hiddenAgencyId);
            }
        });
        this._hiddenLineIds.forEach((isHidden, hiddenLineId) => {
            if (isHidden === true && (0, uuid_1.validate)(hiddenLineId)) {
                hiddenLineIds.push(hiddenLineId);
            }
        });
        this._layerManager.updateFilter(this._layerName, [
            '!',
            ['match', ['get', 'line_id'], hiddenLineIds.length === 0 ? ['none'] : hiddenLineIds, true, false]
        ]);
        ServiceLocator_1.default.eventManager.emit('map.layers.updateFilter');
        Preferences_1.default.update({
            'map.layers.hiddenAgencyIds': hiddenAgencyIds,
            'map.layers.hiddenLineIds': hiddenLineIds
        }, ServiceLocator_1.default.socketEventManager);
    }
}
exports.default = PathMapLayerManager;
//# sourceMappingURL=PathMapLayerManager.js.map